import { render } from "./OrdersByCustomer.vue?vue&type=template&id=34813acf&scoped=true"
import script from "./OrdersByCustomer.vue?vue&type=script&lang=js"
export * from "./OrdersByCustomer.vue?vue&type=script&lang=js"

import "./OrdersByCustomer.vue?vue&type=style&index=0&id=34813acf&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34813acf"]])

export default __exports__